// Module
var code = "<div class=\"horizontal-page-image horizontal-page-image--large image\"> <img src=\"https://user-images.githubusercontent.com/41680436/169303945-73777007-e173-499a-bbd3-579680f7fc83.jpg\" alt=\"\" class=\"image__image\"/> </div> ";
// Exports
export default code;